import React from "react";
import Table, { KebabMenu } from "../../../components/Common/Table";
import Button from "../../../components/Common/Button";
import { deviceTableColumns, DEVICES_PAGE_TITLE } from "../dataFiles/devicesPageDataFile";
import "./DeviceSettings.css";

const tabStyle = (isActive) => ({
  background: "none",
  border: "none",
  borderBottom: isActive ? "3px solid #3b82f6" : "3px solid transparent",
  padding: "10px 20px",
  fontSize: "15px",
  fontWeight: isActive ? 600 : 400,
  color: isActive ? "#1e293b" : "#94a3b8",
  cursor: "pointer",
  transition: "color 0.15s ease, border-color 0.15s ease",
});

export default function DeviceTable({
  devices = [],
  onEdit,
  onDelete,
  onAddDevice,
  hideToolbar = false,
  tabs,
  activeTab,
  onTabChange,
  subHeader,
}) {
  const columns = [
    ...deviceTableColumns,
    ...(onEdit || onDelete
      ? [{
          key: "actions",
          header: "Actions",
          align: "right",
          width: "80px",
          render: (row) => (
            <div className="wg-table__actions">
              <KebabMenu
                items={[
                  ...(onEdit ? [{ label: "Edit", onClick: () => onEdit(row) }] : []),
                  ...(onDelete ? [{ label: "Delete", onClick: () => onDelete(row) }] : []),
                ]}
              />
            </div>
          ),
        }]
      : []),
  ];

  const toolbar = hideToolbar ? undefined : {
    left: (
      <div>
        <h2 className="wg-page-header">{DEVICES_PAGE_TITLE}</h2>
        {subHeader && (
          <p style={{ fontSize: "13px", color: "#64748b", margin: "4px 0 0 0" }}>
            {subHeader}
          </p>
        )}
      </div>
    ),
    right: !tabs && onAddDevice && (
      <Button onClick={onAddDevice}>+ Add Device</Button>
    ),
  };

  const header = tabs ? (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", borderBottom: "1px solid #e2e8f0", marginBottom: "16px" }}>
      <div style={{ display: "flex", gap: "0" }}>
        {tabs.map((tab) => (
          <button
            key={tab.key}
            type="button"
            style={tabStyle(activeTab === tab.key)}
            onClick={() => onTabChange(tab.key)}
          >
            {tab.label} ({tab.count})
          </button>
        ))}
      </div>
      {onAddDevice && (
        <div style={{ paddingBottom: "8px" }}>
          <Button onClick={onAddDevice}>+ Add Device</Button>
        </div>
      )}
    </div>
  ) : undefined;

  return (
    <Table
      columns={columns}
      data={devices}
      rowKey="device_id"
      hoverable
      emptyState="No devices found."
      toolbar={toolbar}
      header={header}
    />
  );
}
